import {
  correspondenceQueryKeys,
  CorrespondenceThreadRoute,
} from "toptaal-shared"
import { createFileRoute, useParams, useRouter } from "@tanstack/react-router"
import { CorrespondenceEntityType } from "toptaal-shared"
import { useOrganizationUserQuery } from "@/api/queries/organizationUser/useOrganizationUserQuery"
import { checkOrganizationPermissions } from "@/utils/checkOrganizationPermissions"

export const Route = createFileRoute(
  "/beheer/groepen/$groupId/correspondentie/$threadId",
)({
  component: RouteComponent,
  beforeLoad: () => checkOrganizationPermissions("read", "groupCorrespondence"),
})

function RouteComponent() {
  const router = useRouter()
  const { data: user } = useOrganizationUserQuery()

  const { groupId: groupIdParam, threadId: threadIdParam } = useParams({
    from: "/beheer/groepen/$groupId/correspondentie/$threadId",
  })
  const entityType: CorrespondenceEntityType = "LessonGroup"
  const threadId = Number(threadIdParam)
  const entityId = Number(groupIdParam)

  const handleNavigateBack = () => {
    router.navigate({
      to: `/beheer/groepen/${groupIdParam}/correspondentie`,
    })
  }

  return (
    <CorrespondenceThreadRoute
      threadId={threadId}
      entityType={entityType}
      entityId={entityId}
      user={user}
      correspondenceQueryKeys={correspondenceQueryKeys}
      onNavigateBack={handleNavigateBack}
      showEditButton={false}
    />
  )
}
